import React, { useState, useEffect } from 'react';

import axios from 'axios';

import UserProfile from './UserProfile';

import MainBar from './components/MainBar';
import Footer from './components/Footer';

import Home from './components/Home';
import Dashboard from './components/Dashboard';
import ManageProducers from './components/ManageProducers';
import ManageAssociations from './components/ManageAssociations';
import ManageMicro from './components/ManageMicro';
import ManageCosts from './components/ManageCosts';
import SupplierReport from './components/SupplierReport';
import Sobre from './components/Sobre';
import Login from './components/Login';

import { Container, Toast } from 'react-bootstrap';

import styled from 'styled-components';

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    Switch,
    Route,
    useHistory,
    Redirect,
} from "react-router-dom";

function App() {
    let history = useHistory();

    const [isLogged, setLogged] = useState(UserProfile.isLogged);
    const [isADM, _isADM] = useState(UserProfile.isADM);
    const [showToast, setShowToast] = useState(false);
    const [geoserverURL, _geoserverURL] = useState(null);

    useEffect(() => {
        async function getGeoserverURL() {
            const { data } = await axios.get(
                `${process.env.REACT_APP_SERVER}geo-service/url`,
            );

            console.log('geoserver: ', data);
            _geoserverURL(data);

        }
        getGeoserverURL();
    }, [])

    const login = async (email, password) => {

        const result = await UserProfile.login(email, password);

        if (result.success) {
            _isADM(UserProfile.isADM);
            setTimeout(()=>setLogged(true), 500); // next tick
            /* TODO: redirect? */
        } else {
            setShowToast(true);
        }
    }

    const logout = () => {
        UserProfile.logout();
        setLogged(false);
        history.push('/');
    }

    return (
        <>
            <NoMarginContainer fluid={true}>
                <MainBar
                    user={UserProfile.user}
                    isLogged={isLogged}
                    isADM={isADM}
                    onLogout={logout}
                />
                <div className="content">
                    <Switch>

                        {isLogged && <Route path="/home"><Home geoserverURL={geoserverURL} /></Route>}
                        {isLogged && isADM && <Route path="/produtores"><ManageProducers /></Route>}
                        {isLogged && isADM && <Route path="/associacoes"><ManageAssociations /></Route>}
                        {isLogged && isADM && <Route path="/microrregioes"><ManageMicro /></Route>}
                        {isLogged && isADM && <Route path="/custos"><ManageCosts /></Route>}
                        {isLogged && <Route path="/relatorio"><SupplierReport /></Route>}
                        {isLogged && isADM && <Route path="/painel"><Dashboard /></Route>}
                        {isLogged && isADM && <Route path="/sobre"><Sobre /></Route>}
                        {!isLogged && <Route path="/login"><Login onLogin={login} /></Route>}
                        <Route path="/">
                            <Redirect to={isLogged ? (isADM ? "/painel" : "/home") : '/login'} />
                        </Route>

                    </Switch>
                </div>
                <Footer />

                <StyledToast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                    <Toast.Header>
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <strong className="mr-auto">Erro</strong>
                    </Toast.Header>
                    <Toast.Body>Login ou Senha incorretos!</Toast.Body>
                </StyledToast>
            </NoMarginContainer>
        </>
    );
}

const NoMarginContainer = styled(Container)`
    padding-left: 0;
    padding-right: 0;
`;

const StyledToast = styled(Toast)`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10000;

    & .toast-header {
        background-color: red;
        color: #fff;
    }

    & .toast-header strong {
        margin: 3px 4px;
    }
`;

export default App;